module.exports = __webpack_public_path__ + "static/media/galerija_2022_0032.43236be9.jpg";